import { c as _c } from "react/compiler-runtime";
import { IcoArrowRightSmall16, type IconProps } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
const ArrowCircleIcon = t0 => {
  const $ = _c(5);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cx("flex size-5 shrink-0 items-center justify-center rounded-full bg-(--color-gray-0)", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IcoArrowRightSmall16 className="size-[15px]" color="quinary" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <span className={t1}>{t2}</span>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default ArrowCircleIcon;